module.exports = __webpack_public_path__ + "static/media/followbn.f42d3c7e.png";